<p style="display: none;">{{title}}</p>
<form [formGroup]="informationPersonal">
<div class="row">
  <div class="col-sm-12 col-md-6">
    <div class="entradas-de-texto-govco">
      <label for="tipoIdendificacionId">Tipo identificación: <span class="required">*</span></label>
      <select placeholder="Tipo de identificación" formControlName="identificationtype"
      class="form-select" id="tipoIdendificacionId" aria-label="Default select example"
       >
        <option value="" selected disabled>Seleccione</option>
        <option *ngFor="let documento of tiposDocumentos" [value]="documento.idTipoIdentificacion">{{documento.descripcion}}</option>
      </select>
    </div>
  </div>

  <!---Columna jurida-->

  <div class="col-sm-12 col-md-6" *ngIf="this.isLegalPerson == true">
    <div class="entradas-de-texto-govco">
      <label for="tipoIdendificacionId">Tipo identificación: <span class="required">*</span></label>
      <select placeholder="Tipo de identificación" formControlName="identificationtype"
      class="form-select" id="tipoIdendificacionId" aria-label="Default select example">
        <option value="" selected disabled>Seleccione</option>
        <option *ngFor="let documento of tiposDocumentos" [value]="documento.idTipoIdentificacion">{{documento.descripcion}}</option>
      </select>
    </div>
  </div>






  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="numero-identificacion">Número Identificación: <span class="required">*</span></label>
          <input formControlName="numeroIdentificacion" type="text"  id="numero-identificacion" placeholder="Número identificación"  />
      </div>
  </div>



  <!--Columna Juridica-->

  <div class="col-sm-12 col-md-6"*ngIf="this.isLegalPerson == true" >
    <div class="entradas-de-texto-govco">
        <label for="numero-identificacion">Número Identificación: <span class="required">*</span></label>
        <input formControlName="numeroIdentificacion" type="text" id="numero-identificacion" placeholder="Número identificación"  />
    </div>
</div>


  <div class="col-sm-12 col-md-6" *ngIf="this.isLegalPerson == true">
    <div class="entradas-de-texto-govco">
      <label for="numero-identificacion">Razón social: <span class="required">*</span></label>
      <input type="text" formControlName="businessname" id="razon-social" placeholder="Razon social"  />
    </div>
  </div>

  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="primer-nombre">Primer nombre: <span class="required">*</span></label>
          <input formControlName="firstname" type="text"  id="primer-nombre" placeholder="Primer nombre"  />
      </div>
  </div>

  <div class="col-sm-12 col-md-6">
      <div class="entradas-de-texto-govco">
          <label for="segundo-nombre">Segundo nombre:</label>
          <input formControlName="secondname" type="text"  id="segundo-nombre" placeholder="Segundo nombre" />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="primer-apellido">Primer apellido: <span class="required">*</span></label>
          <input formControlName="surname" type="text"  id="primer-apellido" placeholder="Primer apellido" />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="segundo-apellido">Segundo apellido: </label>
          <input formControlName="secondsurname" type="text" id="segundo-apellido" placeholder="Segundo apellido" />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="telefono-celular">Teléfono celular: <span class="required">*</span></label>
          <input formControlName="cellphone" type="number"  id="telefono-celular" placeholder="Telefono celular"  />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="telefono-fijo">Teléfono fijo: </label>
          <input formControlName="landline" type="text" id="telefono-fijo" placeholder="Teléfono fijo"  />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" >
      <div class="entradas-de-texto-govco">
          <label for="correo-electronico">Correo electrónico: <span class="required">*</span></label>
          <input formControlName="email" type="text"  id="correo-electronico" placeholder="Correo electrónico"  />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" *ngIf="this.isLegalPerson == false">
      <div class="entradas-de-texto-govco">
          <label for="direccion">Dirección: <span class="required">*</span></label>
          <input formControlName="address" type="text" id="direccion" placeholder="Dirección"  />
      </div>
  </div>

  <div class="col-sm-12 col-md-6" *ngIf="this.isLegalPerson == false">
      <div class="entradas-de-texto-govco">
          <label for="departamento-residencia">Departamento Residencia: <span class="required">*</span></label>
          <input formControlName="departament" type="text" id="departamento-residencia" placeholder="Departamento Residencia"/>
      </div>
  </div>
  <div class="col-sm-12 col-md-6" *ngIf="this.isLegalPerson == false">
      <div class="entradas-de-texto-govco">
          <label for="municipio-residencia">Municipio Residencia: <span class="required">*</span></label>
          <input formControlName="municipality" type="text" id="municipio-residencia" placeholder="Municipio Residencia" />
      </div>
  </div>

</div>
</form>
